import { put, call, takeLatest } from 'redux-saga/effects';
import * as actions from '~/common/redux/actions';
import { fetchESignSummary, validateCoSignDetails } from '~/common/redux/api';
import { FINANCING_URL_ENUMS } from '~/common/utils/constants';
import { E_SIGN_ACCEPT_REQUEST, FETCH_E_SIGN_DOCUMENT_SUMMARY_REQUEST } from '../types';

export function* fetchESignDocumentSummarySaga(action) {
  try {
    yield put(actions.addLoader(`CRITICAL_${FETCH_E_SIGN_DOCUMENT_SUMMARY_REQUEST}`));

    const { docType, packetType, rn } = action.payload;

    const response = (yield call(fetchESignSummary, rn, docType, packetType)).data;

    if (!response || !response.success || !Array.isArray(response.data)) {
      throw new Error();
    }

    yield put(actions.removeLoader(`CRITICAL_${FETCH_E_SIGN_DOCUMENT_SUMMARY_REQUEST}`));
    yield put(actions.fetchESignDocumentSummarySuccess(response.data));
  } catch (e) {
    yield put(actions.removeLoader(`CRITICAL_${FETCH_E_SIGN_DOCUMENT_SUMMARY_REQUEST}`));
    yield put(actions.fetchESignDocumentSummaryFailure(e));
  }
}

export function* eSignAcceptSaga(action) {
  try {
    yield put(actions.addLoader(E_SIGN_ACCEPT_REQUEST));

    const { actionName, signatureRole, rn, callback } = action.payload;

    const urlEnum = FINANCING_URL_ENUMS[actionName];

    const { data: validateDetailsResponse } = yield call(validateCoSignDetails, {
      rn,
      actionName: urlEnum,
      signatureRole,
    });

    if (!validateDetailsResponse?.success || !validateDetailsResponse?.data?.status) {
      throw new Error();
    }

    yield put(actions.removeLoader(E_SIGN_ACCEPT_REQUEST));

    yield put(actions.eSignAcceptSuccess());
    if (typeof callback === 'function') {
      callback();
    }
  } catch (e) {
    const { error } = action.payload;
    yield put(actions.removeLoader(E_SIGN_ACCEPT_REQUEST));

    yield put(actions.eSignAcceptFailure(e));
    if (typeof error === 'function') {
      error();
    }
  }
}

const eSignSaga = [
  takeLatest(FETCH_E_SIGN_DOCUMENT_SUMMARY_REQUEST, fetchESignDocumentSummarySaga),
  takeLatest(E_SIGN_ACCEPT_REQUEST, eSignAcceptSaga),
];

export default eSignSaga;
